import { css } from 'lit';
export const styles = css `
.hds-tab-panel-wrapper{display:block;text-align:left;width:100%}
`;
//# sourceMappingURL=hds-tab-panel.css.js.map